import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useNavigate } from 'react-router-dom';

function MetersReportsTab() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  // Dummy static data for preview
  const meters = [
    {
      _id: '1',
      meterNumber: '123456',
      manufacturer: 'ABC Meters',
      protocol: 'Modbus',
      size: '15mm',
      installationStatus: 'installed',
      status: 'opened',
      initialReading: 100,
      currentReading: 150,
      concentratorSerialNumber: 'CON-001'
    },
    {
      _id: '2',
      meterNumber: '789012',
      manufacturer: 'XYZ Meters',
      protocol: 'LoRa',
      size: '20mm',
      installationStatus: 'not installed',
      status: 'closed',
      initialReading: 200,
      currentReading: 250,
      concentratorSerialNumber: 'CON-002'
    }
  ];

  const filteredMeters = meters.filter(meter =>
    meter.meterNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    meter.manufacturer?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const statusTemplate = (rowData) => {
    const statusColors = {
      opened: 'success',
      closed: 'danger',
      maintenance: 'warning',
      faulty: 'danger'
    };
    return (
      <span className={`badge bg-${statusColors[rowData.status] || 'secondary'}`}>
        {rowData.status}
      </span>
    );
  };

  const installationStatusTemplate = (rowData) => {
    const statusColors = {
      installed: 'success',
      'not installed': 'warning'
    };
    return (
      <span className={`badge bg-${statusColors[rowData.installationStatus] || 'secondary'}`}>
        {rowData.installationStatus}
      </span>
    );
  };

  const handleViewMeter = (rowData) => {
    navigate(`/core/water_meter_management/view_meter/${rowData._id}`, {
      state: { meter: rowData }
    });
  };

  const actionsTemplate = (rowData) => (
    <div>
      <Button
        icon="ti ti-eye"
        className="p-button-rounded p-button-info"
        onClick={() => handleViewMeter(rowData)}
        tooltip="View Details"
      />
    </div>
  );

  return (
    <div className="card">
      <div className="card-body">
        <div className="row mb-3">
          <div className="col-md-3">
            <div className="form-search">
              <i className="ti ti-search"></i>
              <input
                type="search"
                className="form-control"
                placeholder="Search by meter number or manufacturer"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="dt-responsive table-responsive">
          <DataTable
            value={filteredMeters}
            paginator
            rows={10}
            stripedRows
            emptyMessage="No water meters found."
            tableStyle={{ minWidth: '50rem' }}
          >
            <Column field="meterNumber" header="Meter Number" sortable />
            <Column field="manufacturer" header="Manufacturer" sortable />
            <Column field="protocol" header="Protocol" sortable />
            <Column field="size" header="Size" sortable />
            <Column
              field="installationStatus"
              header="Installation Status"
              body={installationStatusTemplate}
              sortable
            />
            <Column
              field="status"
              header="Status"
              body={statusTemplate}
              sortable
            />
            <Column field="initialReading" header="Initial Reading (m³)" sortable />
            <Column field="currentReading" header="Current Reading (m³)" sortable />
            <Column field="concentratorSerialNumber" header="Con Number" sortable />
            <Column header="Actions" body={actionsTemplate} />
          </DataTable>
        </div>
      </div>
    </div>
  );
}

export default MetersReportsTab;
